import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=136b2702&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('136b2702')) {
      api.createRecord('136b2702', component.options)
    } else {
      api.reload('136b2702', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=136b2702&", function () {
      api.rerender('136b2702', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Equipments/Index.vue"
export default component.exports